import styled, { css } from 'styled-components';

export const ButtonContainer = styled.div`
  ${({ $loadingPaypalPayment }) => css`
    display: ${$loadingPaypalPayment ? 'none' : 'block'};
    min-height: 40px
  `}
`;
